import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import * as ApplicationVersionService from "@/common/services/application.version.service"

const URL = process.env.VUE_APP_BACKEND_API_URL;

let stompClient;

export function initializeWebSocket() {
	return connectWebSocket();
}

export function sendWebSocketMessage(message) {
	if (stompClient && stompClient.connected) {
		stompClient.send('/drc/send', {}, message);
	} else {
		console.error(`WebSocket is not connected to ${URL}. Unable to send message.`);
	}
}

export function disconnectWebSocket() {
	if (stompClient && stompClient.connected) {
		stompClient.disconnect();
	}
}

export function connectWebSocket() {
	/**
	 * The promise is not needed here if we want to set up a standard websocket.
	 * It is used now because the business logic to reload browsers of all users.
	 */
	return new Promise((resolve, reject) => {
		const socket = new SockJS(`${URL}/ws`, null, {
			withCredentials: true,
			extraHeaders: {
				Authorization: localStorage.getItem('jwt'),
			},
		});

		stompClient = Stomp.over(socket);

		/**
		 * if you comment the below line you are going to start seeing the console.logs of the StompJS.
		 * Use only for developer purposes.
		 */
		stompClient.debug = null;

		stompClient.connect(
			{},
			async () => {
				stompClient.subscribe('/version/messages', (response) => {
					/**
					 * Here you can handle the response/messages from the backend
					 * you can console log it with console.log(response.body);
					 */
					ApplicationVersionService.updateApplicationVersion();
				});
				logWebSocket(`Successfully connected to the DRC WebSocket.`);
				resolve();
			},
			(error) => {
				console.error(`Error during WebSocket connection to ${URL}:`, error);
				reject(error);
			}
		);

		/**
		 * This recursively will try to reconnect to the backend websocket if the backend stop working for a while.
		 */
		socket.onclose = (event) => {
			const fiveSeconds = 5000;
			console.error(`WebSocket to ${URL} closed. There will be a reconnecting attempt after ${fiveSeconds} seconds.`);
			setTimeout(() => connectWebSocket().then(resolve).catch(reject), fiveSeconds);
		};
	});
}

function logWebSocket(message) {
	console.log(`[DRC] ${message}`);
}

export function incrementApplicationVersion(timeout) {
	if (timeout) {
		setTimeout(() => {
			sendWebSocketMessage('UPDATE APPLICATION VERSION OF ALL USERS');
		}, timeout);
	} else {
		sendWebSocketMessage('UPDATE APPLICATION VERSION OF ALL USERS');
	}
}


